/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_DetailsInputs */

const en_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const fr_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails`)
};

const es_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles`)
};

const it_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli`)
};

const nl_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const pl_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły`)
};

const fi_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedot`)
};

const da_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaljer`)
};

const sv_jobs_details = /** @type {(inputs: Jobs_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaljer`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Jobs_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_details = /** @type {((inputs?: Jobs_DetailsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_DetailsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_details(inputs)
	if (locale === "fr") return fr_jobs_details(inputs)
	if (locale === "es") return es_jobs_details(inputs)
	if (locale === "it") return it_jobs_details(inputs)
	if (locale === "nl") return nl_jobs_details(inputs)
	if (locale === "pl") return pl_jobs_details(inputs)
	if (locale === "fi") return fi_jobs_details(inputs)
	if (locale === "da") return da_jobs_details(inputs)
	if (locale === "sv") return sv_jobs_details(inputs)
	return en_jobs_details(inputs)
});